import { get1DColor, mapRanges } from '../../../data/data1d/Spectrum1D';
import { generateSpectrumFromRanges, } from '../../../data/data1d/Spectrum1D/ranges/generateSpectrumFromRanges';
import { setZoom } from '../helper/Zoom1DManager';
import { setDomain } from './DomainActions';
function handleResurrectSpectrumFromJcamp(draft, action) {
    const { ranges } = action.payload;
    let { spectrum } = action.payload;
    spectrum = {
        ...spectrum,
        ranges: {
            ...spectrum.ranges,
            values: mapRanges(ranges, spectrum),
        },
        display: {
            ...spectrum.display,
            ...get1DColor(spectrum.display, { usedColors: draft.usedColors }),
        },
    };
    draft.data.push(spectrum);
    setDomain(draft);
    setZoom(draft, { scale: 0.8, spectrumID: spectrum.id });
}
function handleResurrectSpectrumFromRanges(draft, action) {
    const { ranges, info } = action.payload;
    const datum = generateSpectrumFromRanges(ranges, info, draft.usedColors);
    if (datum) {
        draft.data.push(datum);
        setDomain(draft, { isYDomainShared: false });
        setZoom(draft, { scale: 0.8, spectrumID: datum.id });
    }
}
function handleToggleSimilarityTree(draft) {
    draft.view.spectra.showSimilarityTree =
        !draft.view.spectra.showSimilarityTree;
}
export { handleResurrectSpectrumFromRanges, handleResurrectSpectrumFromJcamp, handleToggleSimilarityTree, };
